export default {
    /**
     * Call to the API to configure new marketing account
     * @returns {promise}
     */
    configureAccount() {
        return new Promise((resolve, reject) => {
            $.post('/marketing/configure')
                .then((response) => resolve(response))
                .catch((errors) => reject(errors));
        });
    },

    /**
     * Call to the API to send a account verification request
     * @returns {promise}
     */
    sendAccountVerificationRequest() {
        return new Promise((resolve, reject) => {
            $.post('/marketing/account-verification')
                .then((response) => resolve(response.data))
                .catch((errors) => reject(errors.response.data));
        });
    },

    /**
     * Call to the API to get an array of synchronizable attributes
     * @returns {promise}
     */
    getSynchronizableAttributes() {
        return new Promise((resolve, reject) => {
            ApiClient.get('/marketing/attributes/synchronisable')
                .then((response) => resolve(response.data))
                .catch((errors) => reject(errors.response.data));
        });
    },

    /**
     * @param {String} APIUrl
     * @param {Array(number)} data
     * @returns {promise}
     */
    getAttributesRevisionDiff(APIUrl, data) {
        return new Promise((resolve, reject) => {
            ApiClient.post(APIUrl, {}, data)
                .then((response) => resolve(response.data))
                .catch((errors) => reject(errors.response.data));
        });
    },

    /**
     * @param {String} APIUrl
     * @param {Object} data
     * @returns {promise}
     */
    synchronizeAttributes(APIUrl, data) {
        return new Promise((resolve, reject) => {
            ApiClient.post(APIUrl, {}, data)
                .then((response) => resolve(response.data))
                .catch((errors) => reject(errors.response.data));
        });
    },

    /**
     * @returns {promise}
     */
    getConsentDatas() {
        return ApiClient.get('/settings/consent');
    },

    /**
     * @returns {promise}
     */
    updateConsent(data) {
        return ApiClient.put('/settings/consent', {}, data);
    },

    /**
     * @param {Number} companyId
     * @param {Object} consentSettings
     * @returns {Promise}
     */
    updateCompanyConsentSettings(companyId, consentSettings) {
        return ApiClient.put(`/companies/${companyId}/consent`, {}, consentSettings);
    },

    /**
     * @param {Number} individualId
     * @param {Object} consentSettings
     * @returns {Promise}
     */
    updateIndividualConsentSettings(individualId, consentSettings) {
        return ApiClient.put(`/individuals/${individualId}/consent`, {}, consentSettings);
    },

    /**
     * @param {Number} contactId
     * @param {Object} consentSettings
     * @returns {Promise}
     */
    updateContactConsentSettings(contactId, consentSettings) {
        return ApiClient.put(`/contacts/${contactId}/consent`, {}, consentSettings);
    },

    /**
     * @param {Number} companyId
     * @returns {Promise}
     */
    sendCompanyConsentLogsExportRequest(companyId) {
        return ApiClient.post(`/companies/${companyId}/consent/logs/export`);
    },

    /**
     * @param {Number} individualId
     * @returns {Promise}
     */
    sendIndividualConsentLogsExportRequest(individualId) {
        return ApiClient.post(`/individuals/${individualId}/consent/logs/export`);
    },

    /**
     * @param {Number} contactId
     * @returns {Promise}
     */
    sendContactConsentLogsExportRequest(contactId) {
        return ApiClient.post(`/contacts/${contactId}/consent/logs/export`);
    },
};
